export default {
  labels: {
    selectOne: 'เลือกหนึ่งตัวเลือก',
    selectAll: 'เลือกทั้งหมดที่เกี่ยวข้อง',
    typeResponse: 'พิมพ์คำตอบของคุณในกล่องข้อความด้านล่าง',
    recordResponse: 'บันทึกคำตอบเพื่อใช้ตอบคำถาม',
    enterNumeric: 'กรอกคำตอบเป็นตัวเลขในช่องด้านล่าง',
    rateResponseScale: 'ให้คะแนนคำตอบของคุณตามระดับที่กำหนด',
    sliderMinimum: 'ค่าต่ำสุด: {value}',
    sliderMaximum: 'ค่าสูงสุด: {value}',
    selectOneOptionRow: 'เลือกหนึ่งตัวเลือกในแต่ละแถว',
    selectAllOptionsRow: 'เลือกตัวเลือกทั้งหมดที่เกี่ยวข้องในแต่ละแถว',
    dragAndDropResponse: 'ลากและวางตัวเลือกเพื่อลำดับตามความชอบ',
    rankOrderDesktopInstruction: 'ลากและวางรายการเพื่อจัดอันดับ หรือใช้ปุ่ม + เพื่อเพิ่มรายการ ใช้ปุ่มลูกศรเพื่อจัดลำดับใหม่ หรือปุ่มลบเพื่อนำรายการออก',
    alert: "แจ้งเตือน",
    error: 'กรุณาใส่ตัวเลขระหว่าง {min} และ {max}.',
    cameras: 'กล้อง',
    microphones: 'ไมโครโฟน',
    recording: 'การบันทึก',
    noDevicesFound: 'ไม่พบอุปกรณ์',
    camera: 'กล้อง',
    microphone: 'ไมโครโฟน',
    stopRecording: 'หยุดการบันทึก',
    startRecording: 'เริ่มการบันทึก',
    disableCamera: 'ปิดใช้งานกล้อง',
    enableCamera: 'เปิดใช้งานกล้อง',
    disableMicrophone: 'ปิดใช้งานไมโครโฟน',
    enableMicrophone: 'เปิดใช้งานไมโครโฟน',
    settings: 'การตั้งค่า',
    recordingProgress: 'ความคืบหน้าการบันทึก',
    playbackProgress: 'ความคืบหน้าการเล่น',
    play: 'เล่น',
    pause: 'หยุด',
    stop: 'หยุด',
    record: 'บันทึก',
    recordAgain: 'บันทึกอีกครั้ง',
    retry: 'ลองอีกครั้ง',
    done: 'เสร็จสิ้น',
    minRecordTime: 'กรุณาบันทึกคำตอบเป็นเวลา {min} วินาที',
    enlargeImage: 'ขยายรูปภาพ',
    enlargedImage: 'รูปภาพที่ขยาย',
    close: 'ปิด',
    zoomIn: 'ซูมเข้า',
    zoomOut: 'ซูมออก',
    resetZoom: 'รีเซ็ตการซูม',
    zoomLevel: 'ซูม {percentage}%',
    imagePosition: '{current} จาก {total}',
    previousImage: 'รูปภาพก่อนหน้า',
    nextImage: 'รูปภาพถัดไป',
    imageLoading: 'กำลังโหลดรูปภาพ',
    imageLoadFailed: 'ไม่สามารถโหลดรูปภาพได้',
  },
  noSelection: "ไม่มีการเลือก",
  actions: {
    increase: 'เพิ่ม',
    decrease: 'ลด'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'สิ้นสุดการแสดงตัวอย่างแบบสำรวจ',
      titleCompleted: 'เสร็จสิ้นการแสดงตัวอย่างแบบสำรวจ',
      previewModeWarning: 'หน้านี้มองเห็นได้เฉพาะในโหมดตัวอย่างเท่านั้น และจะไม่แสดงต่อผู้ตอบจริง',
      reachedEndPoint: 'แบบสำรวจนี้ได้มาถึงจุดสิ้นสุดแล้ว',
      reachedEndPointCompleted: 'การแสดงตัวอย่างนี้ได้มาถึงจุดสิ้นสุดแล้ว',
      returnToModify: 'กลับไปยังคำถามก่อนหน้าเพื่อแก้ไขคำตอบของคุณและทดสอบเส้นทางแบบสำรวจที่แตกต่าง',
      logic: 'ตรรกะ'
    }
  }
}
